import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PAIN_POINTS } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-sand py-20 sm:py-24" data-id="element-187" data-mp="2lp54sq5qh0t5">
      <div className="mx-auto max-w-4xl px-5" data-id="element-188" data-mp="26xmu97vn7yh6">
        <Reveal className="text-center" data-id="element-189" data-mp="2bxiwb1ks5fu3">
          <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-190" data-mp="2bwhbi5dypez6">
            Si sos profe de Yoga
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-191" data-mp="1xwgbst9fodla">
            Esto te va a sonar familiar:
          </h2>
        </Reveal>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-192" data-mp="1o0lm5e6sli90">
          {PAIN_POINTS.map((point, i) => <Reveal key={point} as="li" delay={i * 0.05} className="flex items-start gap-3 rounded-xl border border-sand bg-cream p-4" data-id="element-193" data-mp="1sz6mrepyi3xz" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-clay/10 text-clay" data-id="element-194" data-mp="3nc5zn02yck1k">
                <XIcon className="h-3.5 w-3.5" data-id="element-195" data-mp="1u1lln1ak1d5o" />
              </span>
              <span className="text-sm leading-relaxed text-ink/80" data-id="element-196" data-mp="1u1bu399v2xxv">{point}</span>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="mt-12 text-center" data-id="element-197" data-mp="27utgr2xugqs4">
          <p className="font-serif text-2xl font-medium italic text-sage-deep sm:text-3xl" data-id="element-198" data-mp="23sop29qyi484">
            ¿Cuántas clases más vas a improvisar?
          </p>
        </Reveal>
      </div>
    </section>;
}